import { useRef } from 'react'
import { Send, Plus } from 'lucide-react'
import TalentPostsTab from './TalentPostsTab'
import SectionBlock from '../UI/SectionBlock'
import SectionHeader from '../UI/SectionHeader'

const PostsSection = ({ talentId, hasPermission }) => {
  const postsRef = useRef(null)

  return (
    <SectionBlock id="posts">
      <SectionHeader
        icon={Send}
        title="Posts"
        action={hasPermission('talent-service', 'talent_post', 'create') ? (
          <button
            onClick={() => postsRef.current?.openForm()}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white text-xs font-medium rounded-lg hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 transition-colors"
          >
            <Plus className="h-3.5 w-3.5" />Add Post
          </button>
        ) : null}
      />
      <TalentPostsTab ref={postsRef} talentId={talentId} showAddButton={false} />
    </SectionBlock>
  )
}

export default PostsSection
